enum UserAdminType {
    Undefined = 0,
    Admin = 1,
    SuperAdmin = 2
}

export default UserAdminType;